(function () {
  'use strict';

  const REWARDS = [
    { goal: 1000, discount: 10 },
    { goal: 1500, discount: 15 },
    { goal: 2000, discount: 20 }
  ];

  const HOST_SELECTOR = 'shadow-dom-container';

  let currentHost = null;
  let shadowObserver = null;
  let updateTimer = null;

  function parseMoney(value) {
    if (!value) return 0;

    return Number(
      String(value)
        .replace(/,/g, '')
        .replace(/[^\d.-]/g, '')
    ) || 0;
  }

  function formatMoney(value) {
    return Math.ceil(value).toLocaleString('en-IN');
  }

  function getShadowRoot() {
    const host = document.querySelector(HOST_SELECTOR);

    if (!host || !host.shadowRoot) {
      return null;
    }

    return host.shadowRoot;
  }

  /*
   * Get the cart value BEFORE the GoKwik discount.
   *
   * Example from your cart:
   *
   * Original total:   ₹1,686.00
   * Discounted total: ₹1,433.10
   *
   * Reward calculation must use ₹1,686.00.
   */
  function getCartTotal(root) {
    const totalSection = root.querySelector('.total-amount');

    if (totalSection) {
      const text = totalSection.textContent || '';

      const matches = text.match(
        /₹\s*[\d,]+(?:\.\d{1,2})?/g
      );

      if (matches && matches.length) {
        const amounts = matches
          .map(function (price) {
            return parseMoney(price);
          })
          .filter(function (price) {
            return price > 0;
          });

        if (amounts.length) {
          /*
           * When GoKwik shows original + discounted price,
           * original cart value is the higher amount.
           */
          return Math.max.apply(null, amounts);
        }
      }
    }

    /*
     * Fallback:
     * No discount currently active.
     */
    const totalElement =
      root.querySelector('.estimated-total-container span');

    if (!totalElement) {
      return 0;
    }

    return parseMoney(totalElement.textContent);
  }

  function getNextReward(total) {
    for (let i = 0; i < REWARDS.length; i++) {
      if (total < REWARDS[i].goal) {
        return REWARDS[i];
      }
    }

    return null;
  }

  function updateRewardMessage() {
    const root = getShadowRoot();

    if (!root) {
      return;
    }

    const messageElement =
      root.querySelector('.next-milestone-text');

    if (!messageElement) {
      return;
    }

    const cartTotal = getCartTotal(root);

    if (cartTotal <= 0) {
      return;
    }

    const nextReward = getNextReward(cartTotal);

    let newMessage = '';

    if (nextReward) {
      const remaining = Math.max(
        0,
        nextReward.goal - cartTotal
      );

      newMessage =
        'Add more ₹' +
        formatMoney(remaining) +
        '  to get ' +
        nextReward.discount +
        '% Additional discount';
    } else {
      newMessage =
        'Congratulations! You unlocked 20% Additional discount';
    }

    /*
     * Avoid unnecessary DOM changes,
     * otherwise MutationObserver can keep firing.
     */
    if (messageElement.textContent.trim() !== newMessage) {
      messageElement.textContent = newMessage;
    }
  }

  function scheduleUpdate(delay) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateRewardMessage();
    }, delay || 80);
  }

  /*
   * Observe the actual GoKwik Shadow DOM.
   *
   * This catches:
   * - quantity +
   * - quantity -
   * - remove product
   * - upsell add
   * - coupon changes
   * - reward changes
   * - GoKwik cart AJAX re-render
   */
  function observeGoKwikCart() {
    const host = document.querySelector(HOST_SELECTOR);

    if (!host || !host.shadowRoot) {
      return false;
    }

    /*
     * Already observing the current cart instance.
     */
    if (host === currentHost && shadowObserver) {
      return true;
    }

    currentHost = host;

    if (shadowObserver) {
      shadowObserver.disconnect();
    }

    shadowObserver = new MutationObserver(function () {
      scheduleUpdate(50);
    });

    shadowObserver.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    scheduleUpdate(20);

    return true;
  }

  /*
   * GoKwik may completely replace:
   *
   * <shadow-dom-container>
   *
   * after AJAX operations.
   *
   * Therefore also observe the main document.
   */
  const hostObserver = new MutationObserver(function () {
    observeGoKwikCart();
    scheduleUpdate(100);
  });

  hostObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * Initial load.
   */
  document.addEventListener('DOMContentLoaded', function () {
    observeGoKwikCart();
    scheduleUpdate(100);
  });

  window.addEventListener('load', function () {
    observeGoKwikCart();
    scheduleUpdate(100);
  });

  /*
   * Catch clicks inside GoKwik's Shadow DOM.
   *
   * Useful for:
   * + quantity
   * - quantity
   * remove
   * upsell + Add
   * coupon interactions
   */
  document.addEventListener(
    'click',
    function (event) {
      const path =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];

      const insideGoKwik = path.some(function (element) {
        return (
          element &&
          element.tagName &&
          element.tagName.toLowerCase() ===
            'shadow-dom-container'
        );
      });

      if (!insideGoKwik) {
        return;
      }

      /*
       * Run several checks because GoKwik AJAX
       * doesn't always finish at the same speed.
       */
      scheduleUpdate(100);

      setTimeout(function () {
        observeGoKwikCart();
        scheduleUpdate(50);
      }, 300);

      setTimeout(function () {
        observeGoKwikCart();
        scheduleUpdate(50);
      }, 700);

      setTimeout(function () {
        observeGoKwikCart();
        scheduleUpdate(50);
      }, 1200);
    },
    true
  );

  /*
   * Monitor AJAX / fetch cart changes.
   *
   * This also helps when products are added
   * from the Shopify product page before the
   * GoKwik cart opens.
   */
  const originalFetch = window.fetch;

  if (originalFetch) {
    window.fetch = function () {
      const args = arguments;

      return originalFetch
        .apply(this, args)
        .then(function (response) {
          let request = '';

          try {
            request =
              args[0] instanceof Request
                ? args[0].url
                : String(args[0] || '');
          } catch (e) {
            request = '';
          }

          if (
            request.includes('/cart/') ||
            request.includes('/cart.js') ||
            request.includes('gokwik') ||
            request.includes('kwikcart')
          ) {
            setTimeout(function () {
              observeGoKwikCart();
              scheduleUpdate(50);
            }, 150);

            setTimeout(function () {
              observeGoKwikCart();
              scheduleUpdate(50);
            }, 500);

            setTimeout(function () {
              observeGoKwikCart();
              scheduleUpdate(50);
            }, 1000);
          }

          return response;
        });
    };
  }

  /*
   * First immediate attempt.
   */
  observeGoKwikCart();

})();